<template>
    <nav class="find-a-doctor-pagination-wrap">
        <ul class="find-a-doctor-pagination">
            <li class="find-a-doctor-pagination__item">
                <button
                    type="button"
                    :class="['find-a-doctor-pagination__button icon -arrow -prev', { '-is-disabled': isInFirstPage }]"
                    @click="onClickPreviousPage"
                    :disabled="isInFirstPage"
                    aria-label="Go to previous page"
                >
                    <span class="sr-only">Previous</span>
                </button>
            </li>
            <li v-for="(page, key) in pages" :key="key" class="find-a-doctor-pagination__item">
                <button
                    type="button"
                    class="find-a-doctor-pagination__button"
                    @click="onClickPage(page.number)"
                    :class="{ '-is-active': isPageActive(page.number) }"
                    :aria-label="`Go to page number ${page.number}`"
                >
                    {{ page.number }}
                </button>
            </li>
            <li class="find-a-doctor-pagination__item">
                <button
                    type="button"
                    :class="['find-a-doctor-pagination__button', 'icon', '-arrow', { '-is-disabled': isInLastPage }]"
                    @click="onClickNextPage"
                    :disabled="isInLastPage"
                    aria-label="Go to next page"
                >
                    <span class="sr-only">Next</span>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>

export default {
    props: {
        totalPages: Number,
        totalResults: Number,
        pageSize: Number,
        maxLinks: Number,
        currentPage: Number,
    },
    methods: {
        isPageActive(page) {
            return this.currentPage === page;
        },
        getNextUrls(count) {
            let end;

            if (count) {
                end = this.currentPage + count;
            } else {
                end = this.totalPages;
            }

            return this.rangeUrls((this.currentPage + 1), end);
        },
        getPrevUrls(count) {
            let start;

            if (count) {
                start = this.currentPage - count;
            } else {
                start = 1;
            }

            return this.rangeUrls(start, (this.currentPage - 1));
        },
        rangeUrls(start, end) {
            let urls = [];

            if (start < 1) {
                start = 1;
            }

            if (end > this.totalPages) {
                end = this.totalPages;
            }

            for (let page = start; page <= end; page += 1) {
                urls.push({
                    number: page,
                    active: false,
                });
            }

            return urls;
        },
        onClickFirstPage() {
            this.$emit('pageChange', 1);
        },
        onClickPreviousPage() {
            this.$emit('pageChange', this.currentPage - 1);
        },
        onClickPage(page) {
            this.$emit('pageChange', page);
        },
        onClickNextPage() {
            this.$emit('pageChange', this.currentPage + 1);
        },
        onClickLastPage() {
            this.$emit('pageChange', this.totalPages);
        },
    },
    computed: {
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
        pages() {
            return [
                ...this.getPrevUrls(this.isInLastPage ? 5 : 3),
                { number: this.currentPage, active: true },
                ...this.getNextUrls(this.isInFirstPage ? 5 : 3)
            ]
        }
    }
}
</script>

